import AuthService from './authService.js';

export default class CheckService 
{
    

    // static ConvertDBItems(itemlist)
    // {
    //     let mappedItems=[];

    //     if(itemlist!==null)
    //     {
    //         mappedItems=itemlist.map(item => new CheckItem(item));
    //     } 
        
    //     return mappedItems;
    // }

    

    static CheckGeneratePdf(item)
    {
        let authService = AuthService.getInstance();
        let itemJson=JSON.stringify(item);
        let url = "/api/Check/GeneratePdfByExportPaymentId/";
        return authService.CallBackendFunctionPut(url,itemJson);
    }
    
}

